import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import Preloader from '../../components/common/preloader'
import { parseHTML } from '../../utils/dom'
import Pagination from './pagination'
import { Nullable } from '../../types/common'

class PaginationInfiniteScroll extends BaseComponent {
  observerOptions: object
  preloaderSelector: string
  preloader: Nullable<HTMLElement>
  preloaderComponent: Preloader
  intersectionObserver: IntersectionObserver

  constructor() {
    super()

    this.observerOptions = { root: null, rootMargin: '0px 0px 200px 0px' }

    this.preloaderSelector = '.loading-spinner'
    this.preloader = this.querySelector(this.preloaderSelector)

    this.preloaderComponent = new Preloader(this.preloader)

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersectionObserve,
      this.observerOptions,
    )

    this.intersectionObserver.observe(this)
  }

  disconnectedCallback(): void {
    this.intersectionObserver.disconnect()
  }

  handleIntersectionObserve = (entries: IntersectionObserverEntry[]): void => {
    const url = this.dataset.url

    if (url) {
      if (!entries[0].isIntersecting) {
        return
      }

      this.intersectionObserver.unobserve(this)

      this.preloaderComponent.show()

      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText)
          const pagination = this.closest<Pagination>('pagination-component')

          this.preloaderComponent.hide()
          this.updateFromHTML(html)

          if (pagination) {
            pagination.updateTargetsFromHTML(html)
          }
        })
        .catch(() => {
          if (!bodyElement.notification) {
            return
          }

          bodyElement.notification.show(
            'Error in infinite scroll component',
            'warning',
          )
        })
    }
  }

  updateFromHTML(html: Document): void {
    const newPagination = html.querySelector<PaginationInfiniteScroll>(
      'pagination-infinite-scroll',
    )
    const url = newPagination?.dataset.url

    if (newPagination && url) {
      this.setPaginationUrl(url)

      this.intersectionObserver.observe(this)
    } else {
      this.removeAttribute('data-url')
    }
  }

  setPaginationUrl(url: string): void {
    this.dataset.url = url
  }
}

export default PaginationInfiniteScroll
